import { useEffect, useState } from 'react';
import PinInput from 'react-pin-input';
import {
  useNavigate,
} from 'react-router-dom';
import Button from '@material-ui/core/Button';
import Divider from '@material-ui/core/Divider';
import FormControl from '@material-ui/core/FormControl';
import Grid from '@material-ui/core/Grid';
import { makeStyles } from '@material-ui/core/styles';
import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline';
import { Skeleton } from '@material-ui/lab';
import PropTypes from 'prop-types';

import { GetDataUserByUsername } from '../../services/users';
import TransitionsModal from '../General/TransitionsModal';

const useStyles = makeStyles((theme) => ({
  titleForm: {
    fontWeight: 'normal',
    fontSize: 15,
    color: theme.palette.common.blue,
    fontFamily: 'Raleway',
    [theme.breakpoints.between('lg', 'xl')]: {
      marginTop: theme.spacing(2),
    },
    [theme.breakpoints.up('xl')]: {
      marginTop: theme.spacing(4),
    },
  },
  titleEmailForm: {
    fontWeight: 'normal',
    fontSize: 15,
    color: theme.palette.common.pink,
    fontFamily: 'Raleway',
  },
  titleSession: {
    fontWeight: 600,
    fontSize: 24,
    color: theme.palette.common.blue,
    fontFamily: 'Raleway',
    marginTop: theme.spacing(5),
    [theme.breakpoints.between('lg', 'xl')]: {
      marginTop: theme.spacing(3),
    },
    [theme.breakpoints.up('xl')]: {
      marginTop: theme.spacing(5),
    },
  },
  sectionDivider: {
    background: theme.palette.common.pink,
    size: '5',
    margin: theme.spacing(1, 1, 1),
    borderBottomWidth: 4,
  },
  input: {
    border: `1px solid ${theme.palette.background.primary}`,
    borderRadius: 'px',
    background: theme.palette.background.default,
    // [theme.breakpoints.down('md')]: {
    //   width: '50px',
    // },
    // [theme.breakpoints.up('md')]: {
    //   width: '50px',
    // },
    marginTop: theme.spacing(3),
    padding: 4,
  },
  error: {
    color: theme.palette.common.red,
    margin: '5px',
  },
  forget: {
    fontWeight: 'normal',
    fontSize: 14,
    color: theme.palette.text.alert,
    fontFamily: 'Raleway',
    marginTop: theme.spacing(2),
  },
  icon: {
    color: 'gray',
  },
  submit: {
    color: theme.palette.background.default,
    boxShadow: theme.shadows[1],
    fontWeight: '400',
    marginTop: theme.spacing(8),
    textTransform: 'capitalize',
    padding: '6px 30px',
    background: theme.palette.background.secondary,
    fontSize: 16,
    fontFamily: 'Raleway',
    '&:hover': {
      background: theme.palette.common.pinkLigth,
    },
    '&:disabled': {
      background: theme.palette.common.gray,
    },
  },
  cancel: {
    color: theme.palette.background.default,
    boxShadow: theme.shadows[1],
    fontWeight: '400',
    marginTop: theme.spacing(8),
    textTransform: 'capitalize',
    padding: '6px 30px',
    background: theme.palette.background.steel,
    fontSize: 16,
    fontFamily: 'Raleway',
    '&:hover': {
      background: theme.palette.common.blueLight,
    },
    '&:disabled': {
      background: theme.palette.common.gray,
    },
  },
  modalFirstPassword: {
    borderRadius: '14px',
    position: 'absolute',
    width: 340,
    height: 220,
    backgroundColor: theme.palette.background.paper,
    border: '2px solid #000',
    boxShadow: theme.shadows[5],
    padding: theme.spacing(4, 4),
  },
  tilteModal: {
    fontWeight: 'normal',
    fontSize: 19,
    color: theme.palette.common.blue,
    fontFamily: 'Raleway',
    marginTop: theme.spacing(4),
    display: 'flex',
    alignItems: 'center',
  },
  btnModal: {
    color: theme.palette.background.default,
    boxShadow: theme.shadows[1],
    fontWeight: '400',
    marginTop: theme.spacing(2),
    textTransform: 'capitalize',
    padding: '6px 38px',
    background: theme.palette.background.secondary,
    fontSize: 16,
    fontFamily: 'Raleway',
    display: 'flex',
    justifyContent: 'center',
  },
  iconModal: {
    color: theme.palette.common.blue,
    marginTop: theme.spacing(4),
    width: 50,
  },
  remember: {
    fontWeight: 'normal',
    fontSize: 14,
    color: theme.palette.common.black,
    textTransform: 'lowercase',
    fontFamily: 'Raleway',
    display: 'flex',
    alignItems: 'center',
    textDecoration: `1px underline ${theme.palette.common.blue}`,
    '&:hover': {
      textDecoration: `1px underline ${theme.palette.common.pink}`,
      color: theme.palette.common.pink,
      cursor: 'pointer',
      background: 'none',
    },
    [theme.breakpoints.between('lg', 'xl')]: {
      marginTop: theme.spacing(1),
    },
    [theme.breakpoints.up('xl')]: {
      marginTop: theme.spacing(3),
    },
  },
  contentButton: {
    [theme.breakpoints.between('lg', 'xl')]: {
      margin: theme.spacing(-6, 1, 0, 1),
    },
    [theme.breakpoints.up('xl')]: {
      margin: theme.spacing(-5, 1),
    },
  },
  skeleton: {
    marginTop: theme.spacing(5),
  },
}));

function PasswordValidateCode({ name }) {
  const classes = useStyles();
  const navigate = useNavigate();
  const isBtnNext = false;

  const [codeOtp, setCodeOtp] = useState('');
  const [email, setEmail] = useState('');
  // const [show, setShow] = useState(true);
  const [openModal, setOpenModal] = useState(false);

  const handleCodeOtp = (event) => {
    setCodeOtp(event);
  };

  // const recover = async () => {
  //   setShow(false);
  //   await ResetPassword(name);
  // };

  const getEmailUser = async () => {
    const dataUser = await GetDataUserByUsername(name);
    setEmail(dataUser.data.UserAttributes[2].Value);
  };

  const nextValidate = () => {
    navigate('/', {
      state: {
        route: '/forgot',
        name,
        setCode: codeOtp,
      },
    });
  };

  const showOrHideAlert = () => {
    setOpenModal(!openModal);
  };

  const navigateBack = () => {
    setOpenModal(false);
    navigate('/');
  };

  const styleIconModal = (e) => <ErrorOutlineIcon className={e} />;

  useEffect(() => {
    getEmailUser();
  }, []);

  return (
    <>
      <Grid
        container
        direction="column"
        justifyContent="center"
        alignItems="center"
      >
        <span className={classes.titleSession}>Validar código</span>
      </Grid>
      <Divider className={classes.sectionDivider} variant="middle" />
      {email ? (
        <Grid
          container
          direction="column"
          justifyContent="center"
          alignItems="center"
          alignContent="center"
        >
          <span className={classes.titleForm}>
            Te hemos enviado un código al siguiente correo:
          </span>
          <span className={classes.titleEmailForm}>{email}</span>
          <span className={classes.titleForm}>
            Busca el mensaje y escribe el código aquí:
          </span>
          <Grid>
            <PinInput
              length={6}
              initialValue=""
              onChange={(event) => {
                handleCodeOtp(event);
              }}
              type="numeric"
              inputMode="number"
              className={classes.inputNumeric}
              style={{ paddingTop: '15px' }}
              inputStyle={{ borderColor: 'gray', borderRadius: '5px' }}
              inputFocusStyle={{ borderColor: 'blue' }}
              onComplete={(event) => {
                handleCodeOtp(event);
              }}
              autoSelect
              regexCriteria={/^[ A-Za-z0-9]*$/}
            />
          </Grid>
          {/* {show ? (
            <Button onClick={recover} className={classes.remember}>
              Volver a enviar código
            </Button>
          ) : null} */}

          <FormControl>
            {isBtnNext ? null : (
              <Grid
                container
                direction="row"
                justifyContent="space-around"
                alignItems="flex-start"
                className={classes.contentButton}
              >
                <Button type="submit" size="large" className={classes.cancel} onClick={showOrHideAlert}>
                  SALIR
                </Button>
                <Button
                  disabled={!(codeOtp.length === 6)}
                  size="large"
                  className={classes.submit}
                  onClick={nextValidate}
                >
                  SIGUIENTE
                </Button>
              </Grid>
            )}
          </FormControl>
          <TransitionsModal
            open={openModal}
            textBody="Si no continuas con el cambio de tu
contraseña, deberás volver a
solicitar un nuevo código en
“He olvidado mi contraseña”"
            textButton="ENTIENDO"
            actionButton={navigateBack}
            handleClose={showOrHideAlert}
            icon={styleIconModal}
          />
        </Grid>
      ) : (
        <Grid
          container
          direction="column"
          justifyContent="center"
          alignItems="center"
          alignContent="center"
          className={classes.skeleton}
        >
          <Skeleton width={280} height={25} animation="wave" />
          <Skeleton width={270} height={15} animation={false} />
          <Skeleton className={classes.skeleton} width={280} height={18} />
          <Skeleton width={280} height={80} />
          <Skeleton width={160} height={15} />
          <Skeleton className={classes.skeleton} width={180} height={65} />
        </Grid>
      )}
    </>
  );
}
PasswordValidateCode.propTypes = {
  name: PropTypes.string.isRequired,
};

export default PasswordValidateCode;
